import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ResendEmailRPC } from "./resendEmailRPC";

export class ResendEmailRPCClientImpl extends ResendEmailRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ResendEmailRPC.Request): Promise<LeoRPCResult<ResendEmailRPC.Response, ResendEmailRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/ResendEmail",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ResendEmailRPC.ResponseDTO,
      ResendEmailRPC.Errors.ErrorsDTO,
      ResendEmailRPC.Response,
      ResendEmailRPC.Errors.Errors
    >(
      response,
      "email-cycle/ResendEmail",
      ResendEmailRPC.Response.fromDTO,
      ResendEmailRPC.Errors.fromDTO
    );
  }
}
